var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4289 7.99979H4.57171V12.682C4.19552 12.633 3.81434 12.5999 3.42885 12.5834V7.99979V6.85693H4.57171H27.4289H28.5717V7.99979V23.9998V25.1426H27.4289H15.9879C15.9715 24.7572 15.9384 24.376 15.8894 23.9998H27.4289V7.99979ZM3.42871 15.6457C8.22292 16.5702 12.0009 20.3482 12.9255 25.1424H11.7591C10.8673 20.9807 7.59039 17.7039 3.42871 16.8121L3.42871 15.6457ZM3.42871 19.165C6.32519 19.9644 8.60676 22.2459 9.40624 25.1424H8.21323C7.48174 22.8782 5.69288 21.0894 3.42871 20.358L3.42871 19.165ZM3.42871 23.2864C4.30569 23.6832 5.04379 24.3328 5.55 25.1424H3.42871L3.42871 23.2864Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastingIcon);
export default __webpack_public_path__ + "static/media/CastingIcon.e63bfe45252d1d97d71ca0ff35965aba.svg";
export { ForwardRef as ReactComponent };